import i18n from '../../i18';
import { Box } from '@mui/material';

const CharacterCounter = ({ charCount, characterLimit }) => {
    return (
        <Box
            sx={{
                textAlign: 'left',
                fontSize: '12px',
                color:
                    charCount >= characterLimit ? 'error.main' : 'primary.main',
                marginTop: '5px',
                paddingRight: '16px'
            }}
        >
            {charCount}/{characterLimit} {i18n.t('text.charactersLeft')}
        </Box>
    );
};
export default CharacterCounter;
